<template>
	<nut-dialog
		teleport="body"
		:title="modalTitle"
		:visible="modelValue"
		@ok="handleConfigSetting"
		@cancel="handleClose"
	>
		<nut-form class="form">
			<template v-if="type === 'view'">
				<nut-form-item label="图片停留时间:">
					<input
						class="nut-input-text"
						placeholder="请输入"
						type="number"
						inputmode="numeric"
						v-model="form.imgStayTime"
					/>
					<span>秒</span>
				</nut-form-item>
				<nut-form-item label="HTML停留时间:">
					<input
						class="nut-input-text"
						placeholder="请输入"
						type="number"
						inputmode="numeric"
						v-model="form.htmlStayTime"
					/>
					<span>秒</span>
				</nut-form-item>
				<nut-form-item label="图片强制全屏:">
					<nut-switch v-model="form.imgIsFullScreen"></nut-switch>
				</nut-form-item>
				<nut-form-item label="视频强制全屏:">
					<nut-switch v-model="form.videoIsFullScreen"></nut-switch>
				</nut-form-item>
				<nut-form-item label="转场效果:">
					<div @click="pickerShow = true">
						{{ selectedText }} &gt;
					</div>
				</nut-form-item>
			</template>

			<!-- 音乐设置 -->
			<template v-if="type === 'audio'">
				<nut-form-item label="循环播放开关:">
					<nut-switch v-model="form.isLoop"></nut-switch>
				</nut-form-item>
			</template>

			<!-- 字幕设置 -->
			<template v-if="type === 'subtitle'">
				<nut-form-item label="循环连播开关:">
					<nut-switch v-model="form.subtitleLoopMode"></nut-switch>
				</nut-form-item>
				<nut-form-item label="滚动速度:">
					<nut-inputnumber max="10" v-model="form.scrollSpeed" />
				</nut-form-item>
				<nut-form-item label="显示位置:">
					<div @click="positionPickerShow = true">
						{{ selectedPositionText }} &gt;
					</div>
				</nut-form-item>
				<nut-form-item label="字体大小:">
					<nut-inputnumber max="10" v-model="form.fontsize" />
				</nut-form-item>
			</template>
		</nut-form>
	</nut-dialog>
	<nut-picker
		v-model="selectedEffect"
		v-model:visible="pickerShow"
		:columns="effectColumns"
		title="转场效果选择"
		@confirm="handleConfirm"
	>
	</nut-picker>
	<nut-picker
		v-model="selectedPosition"
		v-model:visible="positionPickerShow"
		:columns="positionColumns"
		title="显示位置选择"
		@confirm="handlePositionConfirm"
	>
	</nut-picker>
</template>

<script>
const titleMap = {
	view: '图片视频设置',
	subtitle: '字幕设置',
	audio: '音乐设置',
};
import { reactive, ref, computed } from 'vue';
import { playlistApi } from '@/apis';
import { Toast } from '@nutui/nutui';
import { positionColumns, effectColumns } from '@/constants/pickerColumns';

export default {
	name: 'SettingModal',
	props: {
		modelValue: {
			type: Boolean,
			required: true,
		},
		type: {
			type: String,
			default: 'view',
		},
		config: {
			type: Object,
			required: true,
		},
	},
	emits: ['update:modelValue', 'success'],
	setup(props, { emit }) {
		const form = reactive({
			imgStayTime: props.config.picture_time,
			htmlStayTime: props.config.html_time,
			imgIsFullScreen: !!props.config.picture_stretch,
			videoIsFullScreen: !!props.config.video_stretch,
			isLoop: !!props.config.audio_mode, // 音乐设置循环,
			// 字幕
			subtitleLoopMode: !!props.config.subtitle_mode,
			scrollSpeed: props.config.subtitle_speed,
			fontsize: props.config.subtitle_size,
		});
		const pickerShow = ref(false);
		const positionPickerShow = ref(false);
		const selectedEffect = ref([`+${props.config.effect}`]);
		// const selectedText = ref('随机');
		const selectedText = computed(() => {
			return effectColumns.filter(
				(effect) =>
					Number(effect.value) === Number(selectedEffect.value[0])
			)[0]?.text;
		});
		const selectedPosition = ref([props.config.subtitle_location]);
		const selectedPositionText = computed(() => {
			return positionColumns.filter(
				(position) => position.value === selectedPosition.value[0]
			)[0]?.text;
		});
		const modalTitle = computed(() => {
			return titleMap[props.type];
		});

		const handleConfirm = () => {
			// selectedText.value = selectedOptions[0].text;
		};
		const handlePositionConfirm = () => {
			// selectedPosition.value = selectedValue[0];
			// selectedPositionText.value = selectedOptions[0].text;
		};
		const handleClose = () => {
			emit('success');
			emit('update:modelValue', false);
		};
		// 确认更改
		const handleConfigSetting = async () => {
			const intReg = /^[1-9]\d*$/; // 此正则作用为拦截复制粘贴的数据
			if (!intReg.test(String(form.imgStayTime))) {
				return Toast.warn('图片停留时间须为整数～');
			}
			if (!intReg.test(String(form.htmlStayTime))) {
				return Toast.warn('html停留时间须为整数～');
			}
			const type = props.type;
			let param = {};
			let apiName = 'playlist_view_config';
			switch (type) {
				case 'view':
					param = {
						picture_time: form.imgStayTime,
						html_time: form.htmlStayTime,
						effect: Number(selectedEffect.value[0]),
						picture_stretch: Number(form.imgIsFullScreen),
						video_stretch: Number(form.videoIsFullScreen),
					};
					break;
				case 'subtitle':
					param = {
						onoff: Number(form.subtitleLoopMode),
						speed: form.scrollSpeed,
						location: selectedPosition.value[0],
						size: form.fontsize,
					};
					apiName = 'playlist_subtitle_config';
					break;
				case 'audio':
					param = {
						onoff: Number(form.isLoop),
					};
					apiName = 'playlist_audio_config';
			}
			await playlistApi[apiName](param);
			Toast.success('设置成功～');
			handleClose();
		};

		return {
			modalTitle,
			form,
			effectColumns,
			positionColumns,
			pickerShow,
			selectedEffect,
			selectedText,
			positionPickerShow,
			selectedPositionText,
			selectedPosition,

			handleClose,
			handleConfirm,
			handlePositionConfirm,
			handleConfigSetting,
		};
	},
};
</script>

<style lang="scss" scoped>
.form {
	:deep(.nut-cell) {
		padding-left: 0;
		padding-right: 0;
	}
	:deep(.nut-form-item__label) {
		width: 100px;
	}

	:deep(.nut-form-item__body__slots) {
		@include flex-center;
		justify-content: flex-end;
	}
	:deep(.nut-input-text) {
		margin-right: 4px;
		text-align: right;
		font-size: 12px;
	}
}
</style>
